import { render, staticRenderFns } from "./RealNameDetail.vue?vue&type=template&id=a3838026"
import script from "./RealNameDetail.vue?vue&type=script&lang=js"
export * from "./RealNameDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports